import React from 'react';
import IBaseComponent from '../Interfaces/Base/IBaseComponent';
import ISection from '../Interfaces/ISection';
import ISectionCondition from '../Interfaces/ISectionCondition';

type FormflowContext = {
  isComponentModalOpen: boolean;
  currentComponent: IBaseComponent | null;
  currentSection: ISection | null;
  setCurrentComponent: (nextComponent: IBaseComponent, currentSection: ISection) => void;
  setComponentsInSection: (components: IBaseComponent[], section: ISection) => void;
  destroyComponentModalWindow: () => void;
  sections: ISection[];
  updateFormflowWithComponent: (component: IBaseComponent) => void;
  updateFormflowApproverUsers: (users: string[], currentSection: ISection) => void;
  updateFormflowWithCondition: (component: ISectionCondition[], currentSection: ISection) => void;
  removeComponentFromFormflow: (component: IBaseComponent, currentSection: ISection) => void;
  removeSectionFormflow: (index: number, section: ISection, modalIsOpen: boolean) => void;
  openModal: any;
}

export default React.createContext({} as FormflowContext);